// Utils
import { formatMessage } from './i18n';
import { toast, ToastAction } from '@capintel/component-lib/toast';

const notificationTitleError = formatMessage('Notification.Title.Error');

const information = (message: string, action?: ToastAction[]) => {
  toast.info(formatMessage('Notification.Title.Info'), message, action);
};

const success = (message: string, title?: string, action?: ToastAction[]) => {
  toast.success(title || formatMessage('Notification.Title.Success'), message, action);
};

const error = (message: string, title?: string, action?: ToastAction[]) => {
  toast.error(title || notificationTitleError, message, action);
};

const errorFromKey = (key: string, action?: ToastAction[]) => {
  error(formatMessage(`Errors.Keys.${key}`), notificationTitleError, action);
};

const errorLong = (message: string, title?: string, action?: ToastAction[]) => {
  toast.error(title || notificationTitleError, message, action, { duration: Infinity });
};

export default { information, success, error, errorLong, errorFromKey };
